/* eslint-disable */
;(function(root, factory) {
  if (typeof define === 'function' && define.amd) { // AMD
    define([], factory);
  } else if (typeof exports === 'object') { // Node.js
    module.exports = factory();
  } else { // Browser
    var messages = factory();
    for (var key in messages) {
      root.Blockly.Msg[key] = messages[key];
    }
  }
}(this, function() {
// This file was automatically generated.  Do not modify.

'use strict';

var Blockly = Blockly || { Msg: Object.create(null) };

Blockly.Msg["ABORT_MOVE"] = "Abort move";  // untranslated
Blockly.Msg["ADD_COMMENT"] = "Dodaj komentar";
Blockly.Msg["ALT_KEY"] = "Alt";  // untranslated
Blockly.Msg["CANNOT_DELETE_VARIABLE_PROCEDURE"] = "Ne mogu obrisati varijablu '%1' zato što je dio definicije funkcije '%2'";
Blockly.Msg["CHANGE_VALUE_TITLE"] = "Promijeni vrijednost:";
Blockly.Msg["CHROME_OS"] = "ChromeOS";  // untranslated
Blockly.Msg["CLEAN_UP"] = "Uredi blokove";
Blockly.Msg["CLOSE"] = "Close";  // untranslated
Blockly.Msg["COLLAPSED_WARNINGS_WARNING"] = "Sažeti blokovi sadrže upozorenje";
Blockly.Msg["COLLAPSE_ALL"] = "Skupi blokove";
Blockly.Msg["COLLAPSE_BLOCK"] = "Sažmi blok";
Blockly.Msg["COLOUR_BLEND_COLOUR1"] = "boja 1";
Blockly.Msg["COLOUR_BLEND_COLOUR2"] = "boja 2";
Blockly.Msg["COLOUR_BLEND_HELPURL"] = "https://meyerweb.com/eric/tools/color-blend/#:::rgbp";  // untranslated
Blockly.Msg["COLOUR_BLEND_RATIO"] = "omjer";
Blockly.Msg["COLOUR_BLEND_TITLE"] = "pomiješaj";
Blockly.Msg["COLOUR_BLEND_TOOLTIP"] = "Miješa dvije boje u zadanom omjeru (0.0 - 1.0).";
Blockly.Msg["COLOUR_PICKER_HELPURL"] = "https://hr.wikipedia.org/wiki/Boja";
Blockly.Msg["COLOUR_PICKER_TOOLTIP"] = "Odaberi boju iz palete.";
Blockly.Msg["COLOUR_RANDOM_HELPURL"] = "http://randomcolour.com";  // untranslated
Blockly.Msg["COLOUR_RANDOM_TITLE"] = "slučajna boja";
Blockly.Msg["COLOUR_RANDOM_TOOLTIP"] = "Odaberi boju nasumično.";
Blockly.Msg["COLOUR_RGB_BLUE"] = "plavo";
Blockly.Msg["COLOUR_RGB_GREEN"] = "zeleno";
Blockly.Msg["COLOUR_RGB_HELPURL"] = "https://www.december.com/html/spec/colorpercompact.html";  // untranslated
Blockly.Msg["COLOUR_RGB_RED"] = "crveno";
Blockly.Msg["COLOUR_RGB_TITLE"] = "boja sa";
Blockly.Msg["COLOUR_RGB_TOOLTIP"] = "Stvori boju sa zadanom količinom crvene, zelene i plave. Sve vrijednosti moraju biti između 0 i 100.";
Blockly.Msg["COMMAND_KEY"] = "⌘ Command";  // untranslated
Blockly.Msg["CONTROLS_FLOW_STATEMENTS_HELPURL"] = "https://github.com/google/blockly/wiki/Loops#loop-termination-blocks";  // untranslated
Blockly.Msg["CONTROLS_FLOW_STATEMENTS_OPERATOR_BREAK"] = "izađi iz petlje";
Blockly.Msg["CONTROLS_FLOW_STATEMENTS_OPERATOR_CONTINUE"] = "nastavi sa sljedećim ponavljanjem u petlji";
Blockly.Msg["CONTROLS_FLOW_STATEMENTS_TOOLTIP_BREAK"] = "Prekinite postojeću petlju";
Blockly.Msg["CONTROLS_FLOW_STATEMENTS_TOOLTIP_CONTINUE"] = "Preskoči ostatak petlje i nastavi sa sljedećim ponavljanjem";
Blockly.Msg["CONTROLS_FLOW_STATEMENTS_WARNING"] = "Upozorenje: Ovaj blok se može koristiti samo u petlji.";
Blockly.Msg["CONTROLS_FOREACH_HELPURL"] = "https://github.com/google/blockly/wiki/Loops#for-each";  // untranslated
Blockly.Msg["CONTROLS_FOREACH_TITLE"] = "za svaki član %1 u listi %2";
Blockly.Msg["CONTROLS_FOREACH_TOOLTIP"] = "Za svaki član u listi daje varijabli '%1' vrijednost člana i zatim izvrši neke naredbe";
Blockly.Msg["CONTROLS_FOR_HELPURL"] = "https://github.com/google/blockly/wiki/Loops#count-with";  // untranslated
Blockly.Msg["CONTROLS_FOR_TITLE"] = "broji s %1 od %2 do %3 za %4";
Blockly.Msg["CONTROLS_FOR_TOOLTIP"] = "Varijabla '%1' poprima vrijednosti od početnog broja do završnog broja, brojeći u zadanim intervalima i izvršavajući odabrane blokove.";
Blockly.Msg["CONTROLS_IF_ELSEIF_TOOLTIP"] = "Dodaj uvjet bloku.";
Blockly.Msg["CONTROLS_IF_ELSE_TOOLTIP"] = "Dodaj završni, \"vrijedi za sve\" uvjet bloku.";
Blockly.Msg["CONTROLS_IF_HELPURL"] = "https://github.com/google/blockly/wiki/IfElse";  // untranslated
Blockly.Msg["CONTROLS_IF_IF_TOOLTIP"] = "Dodaj, ukloni ili promijeni redoslijed kako biste presložili ovaj blok.";
Blockly.Msg["CONTROLS_IF_MSG_ELSE"] = "inače";
Blockly.Msg["CONTROLS_IF_MSG_ELSEIF"] = "inače ako";
Blockly.Msg["CONTROLS_IF_MSG_IF"] = "ako";
Blockly.Msg["CONTROLS_IF_TOOLTIP_1"] = "ako je vrijednost istinita izvrši neke naredbe";
Blockly.Msg["CONTROLS_IF_TOOLTIP_2"] = "Ako je vrijednost istina, tada izvrši prvi blok naredbi. Inače izvrši drugi blok naredbi.";
Blockly.Msg["CONTROLS_IF_TOOLTIP_3"] = "Ako je prva vrijednost istina, tada izvrši prvi blok naredbi. Inače, ako je druga vrijednost istina izvrši drugi blok naredbi.";
Blockly.Msg["CONTROLS_IF_TOOLTIP_4"] = "Ako je prva vrijednost istina, tada izvrši prvi blok naredbi. Inače, ako je druga vrijednost istina izvrši drugi blok naredbi. Ako niti jedna vrijednost nije istina, izvrši zadnji blok naredbi.";
Blockly.Msg["CONTROLS_REPEAT_HELPURL"] = "https://hr.wikipedia.org/wiki/For_petlja";
Blockly.Msg["CONTROLS_REPEAT_INPUT_DO"] = "radi";
Blockly.Msg["CONTROLS_REPEAT_TITLE"] = "ponovi %1 puta";
Blockly.Msg["CONTROLS_REPEAT_TOOLTIP"] = "Ponovi zadane naredbe više puta.";
Blockly.Msg["CONTROLS_WHILEUNTIL_HELPURL"] = "https://github.com/google/blockly/wiki/Loops#repeat";  // untranslated
Blockly.Msg["CONTROLS_WHILEUNTIL_OPERATOR_UNTIL"] = "ponavljaj do";
Blockly.Msg["CONTROLS_WHILEUNTIL_OPERATOR_WHILE"] = "ponavljaj dok";
Blockly.Msg["CONTROLS_WHILEUNTIL_TOOLTIP_UNTIL"] = "Dok je vrijednost lažna, izvrši izjave.";
Blockly.Msg["CONTROLS_WHILEUNTIL_TOOLTIP_WHILE"] = "Dok je vrijednost istinita, izvrši izjave.";
Blockly.Msg["CONTROL_KEY"] = "Ctrl";  // untranslated
Blockly.Msg["COPY_SHORTCUT"] = "Copy (%1)";  // untranslated
Blockly.Msg["CUT_SHORTCUT"] = "Cut (%1)";  // untranslated
Blockly.Msg["DELETE_ALL_BLOCKS"] = "Obrisati svih %1 blokova?";
Blockly.Msg["DELETE_BLOCK"] = "Obriši blok";
Blockly.Msg["DELETE_KEY"] = "Del";  // untranslated
Blockly.Msg["DELETE_SHORTCUT"] = "Delete block (%1)";  // untranslated
Blockly.Msg["DELETE_VARIABLE"] = "Obriši varijablu '%1'";
Blockly.Msg["DELETE_VARIABLE_CONFIRMATION"] = "Obriši %1 korištenja varijable '%2'?";
Blockly.Msg["DELETE_X_BLOCKS"] = "Obriši %1 blokova";
Blockly.Msg["DIALOG_CANCEL"] = "Odustani";
Blockly.Msg["DIALOG_OK"] = "U redu";
Blockly.Msg["DISABLE_BLOCK"] = "Onemogući blok";
Blockly.Msg["DUPLICATE_BLOCK"] = "Kloniraj";
Blockly.Msg["DUPLICATE_COMMENT"] = "Dupliciraj komentar";
Blockly.Msg["EDIT_BLOCK_CONTENTS"] = "Edit Block contents (%1)";  // untranslated
Blockly.Msg["ENABLE_BLOCK"] = "Omogući blok";
Blockly.Msg["EXPAND_ALL"] = "Proširi blokove";
Blockly.Msg["EXPAND_BLOCK"] = "Proširi blok";
Blockly.Msg["EXTERNAL_INPUTS"] = "Vanjski Ulazi";
Blockly.Msg["FINISH_MOVE"] = "Finish move";  // untranslated
Blockly.Msg["HELP"] = "Pomoć";
Blockly.Msg["HELP_PROMPT"] = "Press %1 for help on keyboard controls";  // untranslated
Blockly.Msg["INLINE_INPUTS"] = "Poravnati Ulazi";
Blockly.Msg["INSERT_BLOCK"] = "Insert Block (%1)";  // untranslated
Blockly.Msg["LINUX"] = "Linux";  // untranslated
Blockly.Msg["LISTS_CREATE_EMPTY_HELPURL"] = "https://github.com/google/blockly/wiki/Lists#create-empty-list";  // untranslated
Blockly.Msg["LISTS_CREATE_EMPTY_TITLE"] = "stvori praznu listu";
Blockly.Msg["LISTS_CREATE_EMPTY_TOOLTIP"] = "Vraća listu, duljine 0, koja ne sadrži podatke";
Blockly.Msg["LISTS_CREATE_WITH_CONTAINER_TITLE_ADD"] = "lista";
Blockly.Msg["LISTS_CREATE_WITH_CONTAINER_TOOLTIP"] = "Dodaj, ukloni ili promijeni redoslijed kako biste presložili blok liste";
Blockly.Msg["LISTS_CREATE_WITH_HELPURL"] = "https://github.com/google/blockly/wiki/Lists#create-list-with";  // untranslated
Blockly.Msg["LISTS_CREATE_WITH_INPUT_WITH"] = "stvori listu s";
Blockly.Msg["LISTS_CREATE_WITH_ITEM_TOOLTIP"] = "Dodaj član u listu";
Blockly.Msg["LISTS_CREATE_WITH_TOOLTIP"] = "Stvara listu s bilo kojim brojem članova";
Blockly.Msg["LISTS_GET_INDEX_FIRST"] = "prvi";
Blockly.Msg["LISTS_GET_INDEX_FROM_END"] = "# od kraja";
Blockly.Msg["LISTS_GET_INDEX_FROM_START"] = "#";
Blockly.Msg["LISTS_GET_INDEX_GET"] = "dohvati";
Blockly.Msg["LISTS_GET_INDEX_GET_REMOVE"] = "uzmi i ukloni";
Blockly.Msg["LISTS_GET_INDEX_HELPURL"] = "https://github.com/google/blockly/wiki/Lists#getting-items-from-a-list";  // untranslated
Blockly.Msg["LISTS_GET_INDEX_LAST"] = "posljednji";
Blockly.Msg["LISTS_GET_INDEX_RANDOM"] = "slučajno";
Blockly.Msg["LISTS_GET_INDEX_REMOVE"] = "ukloni";
Blockly.Msg["LISTS_GET_INDEX_TAIL"] = "";  // untranslated
Blockly.Msg["LISTS_GET_INDEX_TOOLTIP_GET_FIRST"] = "Vraća prvi član liste";
Blockly.Msg["LISTS_GET_INDEX_TOOLTIP_GET_FROM"] = "Vraća član sa zadanog mjesta u listi.";
Blockly.Msg["LISTS_GET_INDEX_TOOLTIP_GET_LAST"] = "Vraća zadnji član liste.";
Blockly.Msg["LISTS_GET_INDEX_TOOLTIP_GET_RANDOM"] = "Vraća slučajno odabrani član u listi.";
Blockly.Msg["LISTS_GET_INDEX_TOOLTIP_GET_REMOVE_FIRST"] = "Uklanja i vraća prvi član u listi.";
Blockly.Msg["LISTS_GET_INDEX_TOOLTIP_GET_REMOVE_FROM"] = "Uklanja i vraća član na zadanom mjestu u listi.";
Blockly.Msg["LISTS_GET_INDEX_TOOLTIP_GET_REMOVE_LAST"] = "Uklanja i vraća zadnji član u listi.";
Blockly.Msg["LISTS_GET_INDEX_TOOLTIP_GET_REMOVE_RANDOM"] = "Uklanja i vraća slučajno odabrani član u listi.";
Blockly.Msg["LISTS_GET_INDEX_TOOLTIP_REMOVE_FIRST"] = "Uklanja prvi član u listi.";
Blockly.Msg["LISTS_GET_INDEX_TOOLTIP_REMOVE_FROM"] = "Uklanja član na odabranom mjestu u listi.";
Blockly.Msg["LISTS_GET_INDEX_TOOLTIP_REMOVE_LAST"] = "Uklanja zadnji član u listi.";
Blockly.Msg["LISTS_GET_INDEX_TOOLTIP_REMOVE_RANDOM"] = "Uklanja slučajno odabrani član u listi.";
Blockly.Msg["LISTS_GET_SUBLIST_END_FROM_END"] = "do # od kraja";
Blockly.Msg["LISTS_GET_SUBLIST_END_FROM_START"] = "do #";
Blockly.Msg["LISTS_GET_SUBLIST_END_LAST"] = "do zadnjeg";
Blockly.Msg["LISTS_GET_SUBLIST_HELPURL"] = "https://github.com/google/blockly/wiki/Lists#getting-a-sublist";  // untranslated
Blockly.Msg["LISTS_GET_SUBLIST_START_FIRST"] = "dohvati podlistu od prvog";
Blockly.Msg["LISTS_GET_SUBLIST_START_FROM_END"] = "uzmi podlistu od # od kraja";
Blockly.Msg["LISTS_GET_SUBLIST_START_FROM_START"] = "dohvati podlistu od #";
Blockly.Msg["LISTS_GET_SUBLIST_TAIL"] = "";  // untranslated
Blockly.Msg["LISTS_GET_SUBLIST_TOOLTIP"] = "Stvara kopiju odabranog dijela liste";
Blockly.Msg["LISTS_INDEX_FROM_END_TOOLTIP"] = "%1 je zadnji član.";
Blockly.Msg["LISTS_INDEX_FROM_START_TOOLTIP"] = "%1 je prvi član.";
Blockly.Msg["LISTS_INDEX_OF_FIRST"] = "nađi prvo pojavljivanje člana";
Blockly.Msg["LISTS_INDEX_OF_HELPURL"] = "https://github.com/google/blockly/wiki/Lists#finding-items-in-a-list";  // untranslated
Blockly.Msg["LISTS_INDEX_OF_LAST"] = "nađi zadnje pojavljivanje člana";
Blockly.Msg["LISTS_INDEX_OF_TOOLTIP"] = "Vraća indeks prvog/zadnjeg pojavljivanja člana u listi. Vraća %1 ako član nije pronađen.";
Blockly.Msg["LISTS_INLIST"] = "u listi";
Blockly.Msg["LISTS_ISEMPTY_HELPURL"] = "https://github.com/google/blockly/wiki/Lists#is-empty";  // untranslated
Blockly.Msg["LISTS_ISEMPTY_TITLE"] = "%1 je prazno";
Blockly.Msg["LISTS_ISEMPTY_TOOLTIP"] = "Vraća istinu ako je lista prazna.";
Blockly.Msg["LISTS_LENGTH_HELPURL"] = "https://github.com/google/blockly/wiki/Lists#length-of";  // untranslated
Blockly.Msg["LISTS_LENGTH_TITLE"] = "duljina %1";
Blockly.Msg["LISTS_LENGTH_TOOLTIP"] = "Vraća duljinu liste.";
Blockly.Msg["LISTS_REPEAT_HELPURL"] = "https://github.com/google/blockly/wiki/Lists#create-list-with";  // untranslated
Blockly.Msg["LISTS_REPEAT_TITLE"] = "stvori listu s članom %1 ponovljenim %2 puta";
Blockly.Msg["LISTS_REPEAT_TOOLTIP"] = "Stvara listu ponavljanjem dane vrijednosti zadani broj puta.";
Blockly.Msg["LISTS_REVERSE_HELPURL"] = "https://github.com/google/blockly/wiki/Lists#reversing-a-list";  // untranslated
Blockly.Msg["LISTS_REVERSE_MESSAGE0"] = "obrnuto %1";
Blockly.Msg["LISTS_REVERSE_TOOLTIP"] = "Obrnuta kopija liste";
Blockly.Msg["LISTS_SET_INDEX_HELPURL"] = "https://github.com/google/blockly/wiki/Lists#in-list--set";  // untranslated
Blockly.Msg["LISTS_SET_INDEX_INPUT_TO"] = "kao";
Blockly.Msg["LISTS_SET_INDEX_INSERT"] = "umetni na";
Blockly.Msg["LISTS_SET_INDEX_SET"] = "postavi";
Blockly.Msg["LISTS_SET_INDEX_TOOLTIP_INSERT_FIRST"] = "Umeće član na početak liste.";
Blockly.Msg["LISTS_SET_INDEX_TOOLTIP_INSERT_FROM"] = "Umeće član na odabrano mjesto u listi.";
Blockly.Msg["LISTS_SET_INDEX_TOOLTIP_INSERT_LAST"] = "Dodaje član na kraj liste.";
Blockly.Msg["LISTS_SET_INDEX_TOOLTIP_INSERT_RANDOM"] = "Umeće član na slučajno odabrano mjesto u listi.";
Blockly.Msg["LISTS_SET_INDEX_TOOLTIP_SET_FIRST"] = "Postavlja prvi član u listi.";
Blockly.Msg["LISTS_SET_INDEX_TOOLTIP_SET_FROM"] = "Postavlja član na odabrano mjesto u listi.";
Blockly.Msg["LISTS_SET_INDEX_TOOLTIP_SET_LAST"] = "Postavlja zadnji član u listi.";
Blockly.Msg["LISTS_SET_INDEX_TOOLTIP_SET_RANDOM"] = "Postavlja slučajno odabrani član u listi.";
Blockly.Msg["LISTS_SORT_HELPURL"] = "https://github.com/google/blockly/wiki/Lists#sorting-a-list";  // untranslated
Blockly.Msg["LISTS_SORT_ORDER_ASCENDING"] = "uzlazno";
Blockly.Msg["LISTS_SORT_ORDER_DESCENDING"] = "silazno";
Blockly.Msg["LISTS_SORT_TITLE"] = "Sortiraj %1 %2 %3";
Blockly.Msg["LISTS_SORT_TOOLTIP"] = "Sortiraj kopiju liste";
Blockly.Msg["LISTS_SORT_TYPE_IGNORECASE"] = "po abecedi, zanemari mala/velika slova";
Blockly.Msg["LISTS_SORT_TYPE_NUMERIC"] = "kao brojeve";
Blockly.Msg["LISTS_SORT_TYPE_TEXT"] = "po abecedi";
Blockly.Msg["LISTS_SPLIT_HELPURL"] = "https://github.com/google/blockly/wiki/Lists#splitting-strings-and-joining-lists";  // untranslated
Blockly.Msg["LISTS_SPLIT_LIST_FROM_TEXT"] = "napravi listu od teksta";
Blockly.Msg["LISTS_SPLIT_TEXT_FROM_LIST"] = "napravi tekst od liste";
Blockly.Msg["LISTS_SPLIT_TOOLTIP_JOIN"] = "Poveži niz tekstova u jedan tekst podijeljen razdjelnikom";
Blockly.Msg["LISTS_SPLIT_TOOLTIP_SPLIT"] = "Podijeli tekst u niz tekstova prema razdjelniku";
Blockly.Msg["LISTS_SPLIT_WITH_DELIMITER"] = "S razdjelnikom";
Blockly.Msg["LOGIC_BOOLEAN_FALSE"] = "laž";
Blockly.Msg["LOGIC_BOOLEAN_HELPURL"] = "https://github.com/google/blockly/wiki/Logic#values";  // untranslated
Blockly.Msg["LOGIC_BOOLEAN_TOOLTIP"] = "Vraća ili istina ili laž.";
Blockly.Msg["LOGIC_BOOLEAN_TRUE"] = "istina";
Blockly.Msg["LOGIC_COMPARE_HELPURL"] = "https://en.wikipedia.org/wiki/Inequality_(mathematics)";  // untranslated
Blockly.Msg["LOGIC_COMPARE_TOOLTIP_EQ"] = "Vraća istina ako su obje ulazne vrijednosti jednake jedna drugoj.";
Blockly.Msg["LOGIC_COMPARE_TOOLTIP_GT"] = "Vraća istina ako je prva ulazna vrijednost veća od druge.";
Blockly.Msg["LOGIC_COMPARE_TOOLTIP_GTE"] = "Vraća istina ako je prva ulazna vrijednost veća ili jednaka od druge.";
Blockly.Msg["LOGIC_COMPARE_TOOLTIP_LT"] = "Vraća istina ako je prva ulazna vrijednost manja od druge.";
Blockly.Msg["LOGIC_COMPARE_TOOLTIP_LTE"] = "Vraća istina ako je prva ulazna vrijednost manja ili jednaka od druge.";
Blockly.Msg["LOGIC_COMPARE_TOOLTIP_NEQ"] = "Vraća istina ako obje ulazne vrijednosti nisu jednake jedna drugoj.";
Blockly.Msg["LOGIC_NEGATE_HELPURL"] = "https://github.com/google/blockly/wiki/Logic#not";  // untranslated
Blockly.Msg["LOGIC_NEGATE_TITLE"] = "ne %1";
Blockly.Msg["LOGIC_NEGATE_TOOLTIP"] = "Vraća istina ako je ulazna vrijednost lažna. Vraća laž ako je ulazna vrijednost istinita.";
Blockly.Msg["LOGIC_NULL"] = "null";
Blockly.Msg["LOGIC_NULL_HELPURL"] = "https://en.wikipedia.org/wiki/Nullable_type";  // untranslated
Blockly.Msg["LOGIC_NULL_TOOLTIP"] = "Vraća null.";
Blockly.Msg["LOGIC_OPERATION_AND"] = "i";
Blockly.Msg["LOGIC_OPERATION_HELPURL"] = "https://github.com/google/blockly/wiki/Logic#logical-operations";  // untranslated
Blockly.Msg["LOGIC_OPERATION_OR"] = "ili";
Blockly.Msg["LOGIC_OPERATION_TOOLTIP_AND"] = "Vraća istina ako su obje ulazne vrijednosti istinite.";
Blockly.Msg["LOGIC_OPERATION_TOOLTIP_OR"] = "Vraća istina ako je barem jedna od ulaznih vrijednosti istinita.";
Blockly.Msg["LOGIC_TERNARY_CONDITION"] = "izraz";
Blockly.Msg["LOGIC_TERNARY_HELPURL"] = "https://en.wikipedia.org/wiki/%3F:";  // untranslated
Blockly.Msg["LOGIC_TERNARY_IF_FALSE"] = "ako je laž";
Blockly.Msg["LOGIC_TERNARY_IF_TRUE"] = "ako je istina";
Blockly.Msg["LOGIC_TERNARY_TOOLTIP"] = "Provjerite uvjet u \"izrazu\". Ako je uvjet istinit, vraća vrijednost \"ako je istinito\"; inače vraća vrijednost \"ako je lažno\".";
Blockly.Msg["MAC_OS"] = "macOS";  // untranslated
Blockly.Msg["MATH_ADDITION_SYMBOL"] = "+";  // untranslated
Blockly.Msg["MATH_ARITHMETIC_HELPURL"] = "https://hr.wikipedia.org/wiki/Aritmetika";
Blockly.Msg["MATH_ARITHMETIC_TOOLTIP_ADD"] = "Vraća zbroj dvaju brojeva.";
Blockly.Msg["MATH_ARITHMETIC_TOOLTIP_DIVIDE"] = "Vraća kvocijent dvaju brojeva.";
Blockly.Msg["MATH_ARITHMETIC_TOOLTIP_MINUS"] = "Vraća razliku dvaju brojeva.";
Blockly.Msg["MATH_ARITHMETIC_TOOLTIP_MULTIPLY"] = "Vraća umnožak dvaju brojeva.";
Blockly.Msg["MATH_ARITHMETIC_TOOLTIP_POWER"] = "Vraća prvi broj podignut na potenciju drugog broja.";
Blockly.Msg["MATH_ATAN2_HELPURL"] = "https://en.wikipedia.org/wiki/Atan2";  // untranslated
Blockly.Msg["MATH_ATAN2_TITLE"] = "atan2 od X:%1 Y:%2";
Blockly.Msg["MATH_ATAN2_TOOLTIP"] = "Vraća vrijednost arkus tangensa točke (X, Y) u stupnjevima od -180 do 180";
Blockly.Msg["MATH_CHANGE_HELPURL"] = "https://en.wikipedia.org/wiki/Programming_idiom#Incrementing_a_counter";  // untranslated
Blockly.Msg["MATH_CHANGE_TITLE"] = "promijeni %1 za %2";
Blockly.Msg["MATH_CHANGE_TOOLTIP"] = "Dodaj broj varijabli '%1'.";
Blockly.Msg["MATH_CONSTANT_HELPURL"] = "https://hr.wikipedia.org/wiki/Matemati%C4%8Dka_konstanta";
Blockly.Msg["MATH_CONSTANT_TOOLTIP"] = "Vraća jednu od uobičajenih konstanti: π (3.141...), e (2.718...), φ (1.618...), sqrt(2) (1.414...), sqrt(1/2) (0.707...) ili ∞ (beskonačnost).";
Blockly.Msg["MATH_CONSTRAIN_HELPURL"] = "https://en.wikipedia.org/wiki/Clamping_(graphics)";  // untranslated
Blockly.Msg["MATH_CONSTRAIN_TITLE"] = "ograniči %1 od %2 do %3";
Blockly.Msg["MATH_CONSTRAIN_TOOLTIP"] = "Ograničava broj da bude unutar zadanih granica (uključivši rubne vrijednosti)";
Blockly.Msg["MATH_DIVISION_SYMBOL"] = "÷";  // untranslated
Blockly.Msg["MATH_IS_DIVISIBLE_BY"] = "je djeljiv s";
Blockly.Msg["MATH_IS_EVEN"] = "je paran";
Blockly.Msg["MATH_IS_NEGATIVE"] = "je negativan";
Blockly.Msg["MATH_IS_ODD"] = "je neparan";
Blockly.Msg["MATH_IS_POSITIVE"] = "je pozitivan";
Blockly.Msg["MATH_IS_PRIME"] = "je prost broj";
Blockly.Msg["MATH_IS_TOOLTIP"] = "Provjerava je li broj paran, neparan, prim, cijeli, pozitivan, negativan ili je djeljiv određenim brojem. Vraća istina ili laž.";
Blockly.Msg["MATH_IS_WHOLE"] = "je cijeli broj";
Blockly.Msg["MATH_MODULO_HELPURL"] = "https://en.wikipedia.org/wiki/Modulo_operation";  // untranslated
Blockly.Msg["MATH_MODULO_TITLE"] = "ostatak pri dijeljenju %1 ÷ %2";
Blockly.Msg["MATH_MODULO_TOOLTIP"] = "Vraća ostatak pri dijeljenju dvaju brojeva.";
Blockly.Msg["MATH_MULTIPLICATION_SYMBOL"] = "×";  // untranslated
Blockly.Msg["MATH_NUMBER_HELPURL"] = "https://hr.wikipedia.org/wiki/Broj";
Blockly.Msg["MATH_NUMBER_TOOLTIP"] = "broj";
Blockly.Msg["MATH_ONLIST_HELPURL"] = "";  // untranslated
Blockly.Msg["MATH_ONLIST_OPERATOR_AVERAGE"] = "prosječna vrijednost liste";
Blockly.Msg["MATH_ONLIST_OPERATOR_MAX"] = "najveća vrijednost u listi";
Blockly.Msg["MATH_ONLIST_OPERATOR_MEDIAN"] = "medijan liste";
Blockly.Msg["MATH_ONLIST_OPERATOR_MIN"] = "najmanja vrijednost u listi";
Blockly.Msg["MATH_ONLIST_OPERATOR_MODE"] = "mod liste";
Blockly.Msg["MATH_ONLIST_OPERATOR_RANDOM"] = "slučajno odabran član liste";
Blockly.Msg["MATH_ONLIST_OPERATOR_STD_DEV"] = "standardna devijacija liste";
Blockly.Msg["MATH_ONLIST_OPERATOR_SUM"] = "zbroj liste";
Blockly.Msg["MATH_ONLIST_TOOLTIP_AVERAGE"] = "Vraća prosjek (aritmetičku sredinu) numeričkih vrijednosti liste.";
Blockly.Msg["MATH_ONLIST_TOOLTIP_MAX"] = "Vraća najveći broj u listi.";
Blockly.Msg["MATH_ONLIST_TOOLTIP_MEDIAN"] = "Vraća srednji broj u listi.";
Blockly.Msg["MATH_ONLIST_TOOLTIP_MIN"] = "Vraća najmanji broj u listi.";
Blockly.Msg["MATH_ONLIST_TOOLTIP_MODE"] = "Vraća listu najčešćih vrijednosti (mod) u listi";
Blockly.Msg["MATH_ONLIST_TOOLTIP_RANDOM"] = "Vraća slučajan član liste.";
Blockly.Msg["MATH_ONLIST_TOOLTIP_STD_DEV"] = "Vraća standardnu devijaciju liste.";
Blockly.Msg["MATH_ONLIST_TOOLTIP_SUM"] = "Vraća zbroj svih brojeva u listi.";
Blockly.Msg["MATH_POWER_SYMBOL"] = "^";  // untranslated
Blockly.Msg["MATH_RANDOM_FLOAT_HELPURL"] = "https://en.wikipedia.org/wiki/Random_number_generation";  // untranslated
Blockly.Msg["MATH_RANDOM_FLOAT_TITLE_RANDOM"] = "slučajan razlomak";
Blockly.Msg["MATH_RANDOM_FLOAT_TOOLTIP"] = "Vraća slučajan razlomak vrijednosti između 0.0 (uključivo) i 1.0 (isključivo)";
Blockly.Msg["MATH_RANDOM_INT_HELPURL"] = "https://en.wikipedia.org/wiki/Random_number_generation";  // untranslated
Blockly.Msg["MATH_RANDOM_INT_TITLE"] = "slučajan cijeli broj između %1 i %2";
Blockly.Msg["MATH_RANDOM_INT_TOOLTIP"] = "Vraća slučajan cijeli broj između dviju zadanih vrijednosti, uključivši i rubne vrijednosti.";
Blockly.Msg["MATH_ROUND_HELPURL"] = "https://en.wikipedia.org/wiki/Rounding";  // untranslated
Blockly.Msg["MATH_ROUND_OPERATOR_ROUND"] = "zaokružiti";
Blockly.Msg["MATH_ROUND_OPERATOR_ROUNDDOWN"] = "zaokružiti na manje";
Blockly.Msg["MATH_ROUND_OPERATOR_ROUNDUP"] = "zaokružiti na više";
Blockly.Msg["MATH_ROUND_TOOLTIP"] = "Zaokružuje broj na više ili manje";
Blockly.Msg["MATH_SINGLE_HELPURL"] = "https://hr.wikipedia.org/wiki/Kvadratni_korijen";
Blockly.Msg["MATH_SINGLE_OP_ABSOLUTE"] = "apsolutna vrijednost";
Blockly.Msg["MATH_SINGLE_OP_ROOT"] = "kvadratni korijen";
Blockly.Msg["MATH_SINGLE_TOOLTIP_ABS"] = "Vraća apsolutnu vrijednost broja.";
Blockly.Msg["MATH_SINGLE_TOOLTIP_EXP"] = "Vraća e na potenciju broja.";
Blockly.Msg["MATH_SINGLE_TOOLTIP_LN"] = "Vraća prirodni logaritam broja.";
Blockly.Msg["MATH_SINGLE_TOOLTIP_LOG10"] = "Vraća logaritam po bazi 10 zadanog broja.";
Blockly.Msg["MATH_SINGLE_TOOLTIP_NEG"] = "Vraća negaciju broja.";
Blockly.Msg["MATH_SINGLE_TOOLTIP_POW10"] = "Vraća 10 na potenciju broja.";
Blockly.Msg["MATH_SINGLE_TOOLTIP_ROOT"] = "Vraća drugi korijen broja.";
Blockly.Msg["MATH_SUBTRACTION_SYMBOL"] = "-";  // untranslated
Blockly.Msg["MATH_TRIG_ACOS"] = "acos";
Blockly.Msg["MATH_TRIG_ASIN"] = "asin";
Blockly.Msg["MATH_TRIG_ATAN"] = "atan";
Blockly.Msg["MATH_TRIG_COS"] = "cos";
Blockly.Msg["MATH_TRIG_HELPURL"] = "https://en.wikipedia.org/wiki/Trigonometric_functions";  // untranslated
Blockly.Msg["MATH_TRIG_SIN"] = "sin";
Blockly.Msg["MATH_TRIG_TAN"] = "tan";
Blockly.Msg["MATH_TRIG_TOOLTIP_ACOS"] = "Vraća arkus kosinus broja.";
Blockly.Msg["MATH_TRIG_TOOLTIP_ASIN"] = "Vraća arkus sinus broja.";
Blockly.Msg["MATH_TRIG_TOOLTIP_ATAN"] = "Vraća arkus tangens broja.";
Blockly.Msg["MATH_TRIG_TOOLTIP_COS"] = "Vraća kosinus stupnjeva (ne radijana).";
Blockly.Msg["MATH_TRIG_TOOLTIP_SIN"] = "Vraća sinus stupnjeva (ne radijana).";
Blockly.Msg["MATH_TRIG_TOOLTIP_TAN"] = "Vraća tangens stupnjeva (ne radijana).";
Blockly.Msg["MOVE_BLOCK"] = "Move Block (%1)";  // untranslated
Blockly.Msg["MOVE_DOWN_CONSTRAINED"] = "Move down constrained";  // untranslated
Blockly.Msg["MOVE_DOWN_UNCONSTRAINED"] = "Move down, unconstrained";  // untranslated
Blockly.Msg["MOVE_LEFT_CONSTRAINED"] = "Move left, constrained";  // untranslated
Blockly.Msg["MOVE_LEFT_UNCONSTRAINED"] = "Move left, unconstrained";  // untranslated
Blockly.Msg["MOVE_RIGHT_CONSTRAINED"] = "Move right constrained";  // untranslated
Blockly.Msg["MOVE_RIGHT_UNCONSTRAINED"] = "Move right, unconstrained";  // untranslated
Blockly.Msg["MOVE_UP_CONSTRAINED"] = "Move up, constrained";  // untranslated
Blockly.Msg["MOVE_UP_UNCONSTRAINED"] = "Move up unconstrained";  // untranslated
Blockly.Msg["NEW_COLOUR_VARIABLE"] = "Kreiraj varijablu s bojama";
Blockly.Msg["NEW_NUMBER_VARIABLE"] = "Kreiraj varijablu s brojkama";
Blockly.Msg["NEW_STRING_VARIABLE"] = "Kreiraj varijablu s nizom slova";
Blockly.Msg["NEW_VARIABLE"] = "Kreiraj varijablu...";
Blockly.Msg["NEW_VARIABLE_TITLE"] = "Ime nove varijable:";
Blockly.Msg["NEW_VARIABLE_TYPE_TITLE"] = "Novi tip varijable:";
Blockly.Msg["OPTION_KEY"] = "⌥ Option";  // untranslated
Blockly.Msg["ORDINAL_NUMBER_SUFFIX"] = "";  // untranslated
Blockly.Msg["PASTE_SHORTCUT"] = "Paste (%1)";  // untranslated
Blockly.Msg["PROCEDURES_ALLOW_STATEMENTS"] = "Dopustite izjave";
Blockly.Msg["PROCEDURES_BEFORE_PARAMS"] = "s:";
Blockly.Msg["PROCEDURES_CALLNORETURN_HELPURL"] = "https://en.wikipedia.org/wiki/Subroutine";  // untranslated
Blockly.Msg["PROCEDURES_CALLNORETURN_TOOLTIP"] = "Pokrenite korisnički definiranu funkciju '%1'.";
Blockly.Msg["PROCEDURES_CALLRETURN_HELPURL"] = "https://en.wikipedia.org/wiki/Subroutine";  // untranslated
Blockly.Msg["PROCEDURES_CALLRETURN_TOOLTIP"] = "Pokrenite korisnički definiranu funkciju '%1' i upotrijebite njenu izlaznu vrijednost";
Blockly.Msg["PROCEDURES_CALL_BEFORE_PARAMS"] = "s:";
Blockly.Msg["PROCEDURES_CALL_DISABLED_DEF_WARNING"] = "Nije moguće pokrenuti korisnički definiranu funkciju '%1' jer je blok definicije onemogućen.";
Blockly.Msg["PROCEDURES_CREATE_DO"] = "Stvori '%1'";
Blockly.Msg["PROCEDURES_DEFNORETURN_COMMENT"] = "Opis funkcije";
Blockly.Msg["PROCEDURES_DEFNORETURN_DO"] = "";  // untranslated
Blockly.Msg["PROCEDURES_DEFNORETURN_HELPURL"] = "https://en.wikipedia.org/wiki/Subroutine";  // untranslated
Blockly.Msg["PROCEDURES_DEFNORETURN_PROCEDURE"] = "napravi nešto";
Blockly.Msg["PROCEDURES_DEFNORETURN_TITLE"] = "za";
Blockly.Msg["PROCEDURES_DEFNORETURN_TOOLTIP"] = "Stvaranje funkcije bez izlazne vrijednosti";
Blockly.Msg["PROCEDURES_DEFRETURN_HELPURL"] = "https://en.wikipedia.org/wiki/Subroutine";  // untranslated
Blockly.Msg["PROCEDURES_DEFRETURN_RETURN"] = "Vrati";
Blockly.Msg["PROCEDURES_DEFRETURN_TOOLTIP"] = "Stvara funkciju s izlaznom vrijednošću";
Blockly.Msg["PROCEDURES_DEF_DUPLICATE_WARNING"] = "Upozorenje: Ova funkcija ima varijable istog imena";
Blockly.Msg["PROCEDURES_HIGHLIGHT_DEF"] = "Označavanje definicije funkcije";
Blockly.Msg["PROCEDURES_IFRETURN_HELPURL"] = "https://c2.com/cgi/wiki?GuardClause";  // untranslated
Blockly.Msg["PROCEDURES_IFRETURN_TOOLTIP"] = "Iako je vrijednost istina, tada vrati drugu vrijednost";
Blockly.Msg["PROCEDURES_IFRETURN_WARNING"] = "Upozorenje: Ovaj blok se može koristiti samo u definiciji funkcije";
Blockly.Msg["PROCEDURES_MUTATORARG_TITLE"] = "Naziv ulazne varijable";
Blockly.Msg["PROCEDURES_MUTATORARG_TOOLTIP"] = "Dodajte ulaznu varijablu funkcije";
Blockly.Msg["PROCEDURES_MUTATORCONTAINER_TITLE"] = "Ulazne varijable";
Blockly.Msg["PROCEDURES_MUTATORCONTAINER_TOOLTIP"] = "Dodajte, uklonite ili promijenite redoslijed ulaznih varijabli funkcije";
Blockly.Msg["REDO"] = "Ponovi";
Blockly.Msg["REMOVE_COMMENT"] = "Obriši komentar";
Blockly.Msg["RENAME_VARIABLE"] = "Preimenovanje varijable...";
Blockly.Msg["RENAME_VARIABLE_TITLE"] = "Preimenuj svih %1 varijabli u:";
Blockly.Msg["SHORTCUTS_CODE_NAVIGATION"] = "Code navigation";  // untranslated
Blockly.Msg["SHORTCUTS_EDITING"] = "Editing";  // untranslated
Blockly.Msg["SHORTCUTS_GENERAL"] = "General";  // untranslated
Blockly.Msg["START_MOVE"] = "Start move";  // untranslated
Blockly.Msg["TEXT_APPEND_HELPURL"] = "https://github.com/google/blockly/wiki/Text#text-modification";  // untranslated
Blockly.Msg["TEXT_APPEND_TITLE"] = "varijabli %1 dodajte tekst %2";
Blockly.Msg["TEXT_APPEND_TOOLTIP"] = "Dodajte neki tekst varijabli '%1'.";
Blockly.Msg["TEXT_CHANGECASE_HELPURL"] = "https://github.com/google/blockly/wiki/Text#adjusting-text-case";  // untranslated
Blockly.Msg["TEXT_CHANGECASE_OPERATOR_LOWERCASE"] = "u mala slova";
Blockly.Msg["TEXT_CHANGECASE_OPERATOR_TITLECASE"] = "u Prvo Veliko Slovo";
Blockly.Msg["TEXT_CHANGECASE_OPERATOR_UPPERCASE"] = "u VELIKA SLOVA";
Blockly.Msg["TEXT_CHANGECASE_TOOLTIP"] = "Vraća kopiju teksta s malim ili velikim slovima";
Blockly.Msg["TEXT_CHARAT_FIRST"] = "dohvati prvo slovo";
Blockly.Msg["TEXT_CHARAT_FROM_END"] = "dohvati slovo # od kraja";
Blockly.Msg["TEXT_CHARAT_FROM_START"] = "dohvati slovo #";
Blockly.Msg["TEXT_CHARAT_HELPURL"] = "https://github.com/google/blockly/wiki/Text#extracting-text";  // untranslated
Blockly.Msg["TEXT_CHARAT_LAST"] = "dohvati zadnje slovo";
Blockly.Msg["TEXT_CHARAT_RANDOM"] = "dohvati slučajno slovo";
Blockly.Msg["TEXT_CHARAT_TAIL"] = "";  // untranslated
Blockly.Msg["TEXT_CHARAT_TITLE"] = "u tekstu %1 %2";
Blockly.Msg["TEXT_CHARAT_TOOLTIP"] = "Vraća slovo koje je na zadanom mjestu";
Blockly.Msg["TEXT_COUNT_HELPURL"] = "https://github.com/google/blockly/wiki/Text#counting-substrings";  // untranslated
Blockly.Msg["TEXT_COUNT_MESSAGE0"] = "prebroji %1 u %2";
Blockly.Msg["TEXT_COUNT_TOOLTIP"] = "Prebrojava koliko puta se neki tekst pojavljuje u drugom tekstu";
Blockly.Msg["TEXT_CREATE_JOIN_ITEM_TOOLTIP"] = "Dodajte stavku u tekst";
Blockly.Msg["TEXT_CREATE_JOIN_TITLE_JOIN"] = "poveži";
Blockly.Msg["TEXT_CREATE_JOIN_TOOLTIP"] = "Dodaj, ukloni ili promijeni redoslijed kako biste presložili ovaj tekstualni blok";
Blockly.Msg["TEXT_GET_SUBSTRING_END_FROM_END"] = "do slova # od kraja";
Blockly.Msg["TEXT_GET_SUBSTRING_END_FROM_START"] = "do slova #";
Blockly.Msg["TEXT_GET_SUBSTRING_END_LAST"] = "do zadnjeg slova";
Blockly.Msg["TEXT_GET_SUBSTRING_HELPURL"] = "https://github.com/google/blockly/wiki/Text#extracting-a-region-of-text";  // untranslated
Blockly.Msg["TEXT_GET_SUBSTRING_INPUT_IN_TEXT"] = "u tekstu";
Blockly.Msg["TEXT_GET_SUBSTRING_START_FIRST"] = "dohvati podtekst od prvog slova";
Blockly.Msg["TEXT_GET_SUBSTRING_START_FROM_END"] = "dohvati podtekst od slova # od kraja";
Blockly.Msg["TEXT_GET_SUBSTRING_START_FROM_START"] = "dohvati podtekst od slova #";
Blockly.Msg["TEXT_GET_SUBSTRING_TAIL"] = "";  // untranslated
Blockly.Msg["TEXT_GET_SUBSTRING_TOOLTIP"] = "Daje traženi dio teksta";
Blockly.Msg["TEXT_INDEXOF_HELPURL"] = "https://github.com/google/blockly/wiki/Text#finding-text";  // untranslated
Blockly.Msg["TEXT_INDEXOF_OPERATOR_FIRST"] = "nađi prvo pojavljivanje teksta";
Blockly.Msg["TEXT_INDEXOF_OPERATOR_LAST"] = "nađi zadnje pojavljivanje teksta";
Blockly.Msg["TEXT_INDEXOF_TITLE"] = "u tekstu %1 %2 %3";
Blockly.Msg["TEXT_INDEXOF_TOOLTIP"] = "Vraća indeks prvog/zadnjeg pojavljivanja prvog teksta u drugom tekstu. Vraća vrijednost %1 ako tekst nije pronađen.";
Blockly.Msg["TEXT_ISEMPTY_HELPURL"] = "https://github.com/google/blockly/wiki/Text#checking-for-empty-text";  // untranslated
Blockly.Msg["TEXT_ISEMPTY_TITLE"] = "%1 je prazno";
Blockly.Msg["TEXT_ISEMPTY_TOOLTIP"] = "Vraća vrijednost istina ako je dani tekst prazan";
Blockly.Msg["TEXT_JOIN_HELPURL"] = "https://github.com/google/blockly/wiki/Text#text-creation";  // untranslated
Blockly.Msg["TEXT_JOIN_TITLE_CREATEWITH"] = "stvori tekst od";
Blockly.Msg["TEXT_JOIN_TOOLTIP"] = "Stvara tekst povezivanjem bilo kojeg broja dijelova";
Blockly.Msg["TEXT_LENGTH_HELPURL"] = "https://github.com/google/blockly/wiki/Text#text-modification";  // untranslated
Blockly.Msg["TEXT_LENGTH_TITLE"] = "duljina %1";
Blockly.Msg["TEXT_LENGTH_TOOLTIP"] = "Vraća broj slova (uključivši razmake) teksta";
Blockly.Msg["TEXT_PRINT_HELPURL"] = "https://github.com/google/blockly/wiki/Text#printing-text";  // untranslated
Blockly.Msg["TEXT_PRINT_TITLE"] = "ispiši %1";
Blockly.Msg["TEXT_PRINT_TOOLTIP"] = "Ispisuje određeni tekst, broj ili drugu vrijednost.";
Blockly.Msg["TEXT_PROMPT_HELPURL"] = "https://github.com/google/blockly/wiki/Text#getting-input-from-the-user";  // untranslated
Blockly.Msg["TEXT_PROMPT_TOOLTIP_NUMBER"] = "Zatraži broj od korisnika.";
Blockly.Msg["TEXT_PROMPT_TOOLTIP_TEXT"] = "Zatraži tekst od korisnika";
Blockly.Msg["TEXT_PROMPT_TYPE_NUMBER"] = "Zatraži broj porukom";
Blockly.Msg["TEXT_PROMPT_TYPE_TEXT"] = "Zatraži tekst porukom";
Blockly.Msg["TEXT_REPLACE_HELPURL"] = "https://github.com/google/blockly/wiki/Text#replacing-substrings";  // untranslated
Blockly.Msg["TEXT_REPLACE_MESSAGE0"] = "zamijeni %1 s %2 u %3";
Blockly.Msg["TEXT_REPLACE_TOOLTIP"] = "Zamijeni sva pojavljivanja nekog teksta u drugom tekstu.";
Blockly.Msg["TEXT_REVERSE_HELPURL"] = "https://github.com/google/blockly/wiki/Text#reversing-text";  // untranslated
Blockly.Msg["TEXT_REVERSE_MESSAGE0"] = "obrnuto %1";
Blockly.Msg["TEXT_REVERSE_TOOLTIP"] = "Okreće redoslijed znakova u tekstu";
Blockly.Msg["TEXT_TEXT_HELPURL"] = "https://en.wikipedia.org/wiki/String_(computer_science)";  // untranslated
Blockly.Msg["TEXT_TEXT_TOOLTIP"] = "Slovo, riječ ili linija teksta";
Blockly.Msg["TEXT_TRIM_HELPURL"] = "https://github.com/google/blockly/wiki/Text#trimming-removing-spaces";  // untranslated
Blockly.Msg["TEXT_TRIM_OPERATOR_BOTH"] = "ukloni razmake s obje strane od";
Blockly.Msg["TEXT_TRIM_OPERATOR_LEFT"] = "ukloni razmake s lijeve strane od";
Blockly.Msg["TEXT_TRIM_OPERATOR_RIGHT"] = "ukloni razmake s desne strane od";
Blockly.Msg["TEXT_TRIM_TOOLTIP"] = "Vraća kopiju teksta s uklonjenim razmakom s početka ili kraja";
Blockly.Msg["TODAY"] = "Danas";
Blockly.Msg["UNDO"] = "Poništi";
Blockly.Msg["UNKNOWN"] = "Unknown";  // untranslated
Blockly.Msg["UNNAMED_KEY"] = "neimenovano";
Blockly.Msg["VARIABLES_DEFAULT_NAME"] = "stavka";
Blockly.Msg["VARIABLES_GET_CREATE_SET"] = "Stvori 'set %1'";
Blockly.Msg["VARIABLES_GET_HELPURL"] = "https://github.com/google/blockly/wiki/Variables#get";  // untranslated
Blockly.Msg["VARIABLES_GET_TOOLTIP"] = "Vraća vrijednost varijable";
Blockly.Msg["VARIABLES_SET"] = "Postavi %1 na %2";
Blockly.Msg["VARIABLES_SET_CREATE_GET"] = "Stvori 'get %1'";
Blockly.Msg["VARIABLES_SET_HELPURL"] = "https://github.com/google/blockly/wiki/Variables#set";  // untranslated
Blockly.Msg["VARIABLES_SET_TOOLTIP"] = "Postavi vrijednost varijable jednaku izlaznoj vrijednosti";
Blockly.Msg["VARIABLE_ALREADY_EXISTS"] = "Varijabla s nazivom '%1' već postoji.";
Blockly.Msg["VARIABLE_ALREADY_EXISTS_FOR_ANOTHER_TYPE"] = "Varijabla pod nazivom '%1' već postoji za drugi tip: '%2'";
Blockly.Msg["VARIABLE_ALREADY_EXISTS_FOR_A_PARAMETER"] = "Varijabla pod nazivom '%1' već postoji kao parametar u proceduri '%2'.";
Blockly.Msg["WINDOWS"] = "Windows";  // untranslated
Blockly.Msg["WORKSPACE_ARIA_LABEL"] = "Radni prostor Blocklyja";
Blockly.Msg["WORKSPACE_COMMENT_DEFAULT_TEXT"] = "Recite nešto";
Blockly.Msg["CONTROLS_FOREACH_INPUT_DO"] = Blockly.Msg["CONTROLS_REPEAT_INPUT_DO"];
Blockly.Msg["CONTROLS_FOR_INPUT_DO"] = Blockly.Msg["CONTROLS_REPEAT_INPUT_DO"];
Blockly.Msg["CONTROLS_IF_ELSEIF_TITLE_ELSEIF"] = Blockly.Msg["CONTROLS_IF_MSG_ELSEIF"];
Blockly.Msg["CONTROLS_IF_ELSE_TITLE_ELSE"] = Blockly.Msg["CONTROLS_IF_MSG_ELSE"];
Blockly.Msg["CONTROLS_IF_IF_TITLE_IF"] = Blockly.Msg["CONTROLS_IF_MSG_IF"];
Blockly.Msg["CONTROLS_IF_MSG_THEN"] = Blockly.Msg["CONTROLS_REPEAT_INPUT_DO"];
Blockly.Msg["CONTROLS_WHILEUNTIL_INPUT_DO"] = Blockly.Msg["CONTROLS_REPEAT_INPUT_DO"];
Blockly.Msg["LISTS_CREATE_WITH_ITEM_TITLE"] = Blockly.Msg["VARIABLES_DEFAULT_NAME"];
Blockly.Msg["LISTS_GET_INDEX_HELPURL"] = Blockly.Msg["LISTS_INDEX_OF_HELPURL"];
Blockly.Msg["LISTS_GET_INDEX_INPUT_IN_LIST"] = Blockly.Msg["LISTS_INLIST"];
Blockly.Msg["LISTS_GET_SUBLIST_INPUT_IN_LIST"] = Blockly.Msg["LISTS_INLIST"];
Blockly.Msg["LISTS_INDEX_OF_INPUT_IN_LIST"] = Blockly.Msg["LISTS_INLIST"];
Blockly.Msg["LISTS_SET_INDEX_INPUT_IN_LIST"] = Blockly.Msg["LISTS_INLIST"];
Blockly.Msg["MATH_CHANGE_TITLE_ITEM"] = Blockly.Msg["VARIABLES_DEFAULT_NAME"];
Blockly.Msg["PROCEDURES_DEFRETURN_COMMENT"] = Blockly.Msg["PROCEDURES_DEFNORETURN_COMMENT"];
Blockly.Msg["PROCEDURES_DEFRETURN_DO"] = Blockly.Msg["PROCEDURES_DEFNORETURN_DO"];
Blockly.Msg["PROCEDURES_DEFRETURN_PROCEDURE"] = Blockly.Msg["PROCEDURES_DEFNORETURN_PROCEDURE"];
Blockly.Msg["PROCEDURES_DEFRETURN_TITLE"] = Blockly.Msg["PROCEDURES_DEFNORETURN_TITLE"];
Blockly.Msg["TEXT_APPEND_VARIABLE"] = Blockly.Msg["VARIABLES_DEFAULT_NAME"];
Blockly.Msg["TEXT_CREATE_JOIN_ITEM_TITLE_ITEM"] = Blockly.Msg["VARIABLES_DEFAULT_NAME"];

Blockly.Msg["MATH_HUE"] = "230";
Blockly.Msg["LOOPS_HUE"] = "120";
Blockly.Msg["LISTS_HUE"] = "260";
Blockly.Msg["LOGIC_HUE"] = "210";
Blockly.Msg["VARIABLES_HUE"] = "330";
Blockly.Msg["TEXTS_HUE"] = "160";
Blockly.Msg["PROCEDURES_HUE"] = "290";
Blockly.Msg["COLOUR_HUE"] = "20";
Blockly.Msg["VARIABLES_DYNAMIC_HUE"] = "310";
return Blockly.Msg;
}));
